export default function Footer() {
  function toRoman(num) {
    const romanNumerals = [
      { value: 1000, numeral: 'M' },
      { value: 900, numeral: 'CM' },
      { value: 500, numeral: 'D' },
      { value: 400, numeral: 'CD' },
      { value: 100, numeral: 'C' },
      { value: 90, numeral: 'XC' },
      { value: 50, numeral: 'L' },
      { value: 40, numeral: 'XL' },
      { value: 10, numeral: 'X' },
      { value: 9, numeral: 'IX' },
      { value: 5, numeral: 'V' },
      { value: 4, numeral: 'IV' },
      { value: 1, numeral: 'I' },
    ]
    let result = ''
    for (const { value, numeral } of romanNumerals) {
      while (num >= value) {
        result += numeral
        num -= value
      }
    }
    return result
  }

  return (
    <footer className="w-full pt-6 pb-4 text-center text-xs text-gray-500">
      <div className="flex flex-col items-center space-y-2">
        <span>
          © {toRoman(2023)}–{toRoman(new Date().getFullYear())} SELFIEBOT.RU
        </span>
        <span>
          Разработано{' '}
          <a
            href="https://pavelveter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-blue-500 transition-colors"
          >
            PAVELVETER.COM
          </a>
        </span>
        <a
          href="https://selfiebot.ru/pd"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[0.65rem] text-gray-400 underline hover:text-blue-400"
        >
          Политика обработки ПД
        </a>
      </div>
    </footer>
  )
}
